import styled from '@emotion/styled';
import { Button } from '@mgmresorts/mgm-ui';

export const StyledLink = styled(Button)`
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentL}px;
`;
